if (!window.shopponiLocaleFetchPatched) {
  window.shopponiLocaleFetchPatched = true;
  const shopponiNativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    let localizedInput = input;
    if (typeof input === 'string' && input === '/cart/update.js') {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      localizedInput = root + 'cart/update.js';
    }
    return shopponiNativeFetch(localizedInput, init);
  };
}

if (typeof FacetFiltersForm !== 'undefined') {
  const shopponiOriginalRenderProductCount = FacetFiltersForm.renderProductCount;

  FacetFiltersForm.renderProductCount = function (html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const sourceCount = parsedHTML.getElementById('ProductCount');
    const targetCount = document.getElementById('ProductCount');

    if (!sourceCount || !targetCount) {
      document.querySelectorAll('.product-count').forEach((container) => {
        container.classList.remove('loading');
      });
      document.querySelectorAll('.product-count .loading__spinner').forEach((spinner) => {
        spinner.classList.add('hidden');
      });
      return;
    }

    return shopponiOriginalRenderProductCount.call(this, html);
  };
}
